import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "../lib/api";

async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data.path;
}

export const ImageUploader = ({ value = [], onChange, multiple = true, testId = "image-uploader", aspect = "aspect-square", max = 8 }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const list = multiple ? value : value ? [value] : [];

  const handleFiles = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    try {
      const picked = Array.from(files).slice(0, multiple ? max - list.length : 1);
      const paths = [];
      for (const f of picked) paths.push(await uploadFile(f));
      onChange(multiple ? [...list, ...paths] : paths[0]);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (i) => onChange(multiple ? list.filter((_, idx) => idx !== i) : "");
  const canAdd = multiple ? list.length < max : list.length === 0;

  return (
    <div className={`grid gap-3 ${multiple ? "grid-cols-3 sm:grid-cols-4" : "grid-cols-1"}`} data-testid={testId}>
      {list.map((p, i) => (
        <div key={p + i} className={`relative ${aspect} overflow-hidden rounded-xl border border-slate-200 bg-slate-50 group`}>
          <img src={fileUrl(p)} alt="" className="h-full w-full object-cover" />
          {multiple && i === 0 && <span className="absolute left-1.5 top-1.5 rounded-md bg-slate-900/80 px-1.5 py-0.5 text-[10px] font-semibold text-white">Utama</span>}
          <button type="button" onClick={() => remove(i)} data-testid={`${testId}-remove-${i}`}
            className="absolute right-1.5 top-1.5 grid h-6 w-6 place-items-center rounded-full bg-white/90 text-slate-700 shadow hover:bg-red-500 hover:text-white transition-colors">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
      {canAdd && (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${testId}-add`}
          className={`${aspect} grid place-items-center rounded-xl border-2 border-dashed border-slate-200 text-slate-400 hover:border-slate-400 hover:text-slate-600 transition-colors`}>
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : (
            <span className="flex flex-col items-center gap-1 text-xs font-medium"><ImagePlus className="h-5 w-5" />Upload foto</span>
          )}
        </button>
      )}
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" multiple={multiple}
        className="hidden" onChange={(e) => handleFiles(e.target.files)} data-testid={`${testId}-input`} />
    </div>
  );
};
